import { useLogger } from '@amzn/event-engine-js-utils';
import { useIsMounted } from 'hooks';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppSettings from 'services/app-settings';

import { RouteParams } from '../../constants/routes';

export interface UseContentBuildOutput {
    isLoading: boolean;
    isError: boolean;
    contentId: string | undefined;
    publicContentBaseUrl: string;
    kinesisFirehoseStreamLocale: string | undefined;
    quickLinkId: string | undefined;
}

const useContentBuild = (): UseContentBuildOutput => {
    const [logger] = useLogger('UseContentBuild');
    const { isMounted } = useIsMounted();
    const { contentId, quickLinkId } = useParams<RouteParams>();
    const [isError, setIsError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [publicContentBaseUrl, setPublicContentBaseUrl] = useState<string>(
        ''
    );
    const [
        kinesisFirehoseStreamLocale,
        setKinesisFirehoseStreamLocale,
    ] = useState<string>('');

    useEffect(() => {
        const getAppSettings = async () => {
            setIsLoading(true);

            try {
                const appSettings = await AppSettings();

                if (isMounted.current) {
                    setPublicContentBaseUrl(
                        appSettings.staticContentEndpoint
                            ? `https://${appSettings.staticContentEndpoint}/public`
                            : ''
                    );
                    setKinesisFirehoseStreamLocale(
                        appSettings.kinesisFirehoseStreamLocale
                    );
                }
            } catch (e) {
                logger.error(e);
                isMounted.current && setIsError(true);
            }

            isMounted.current && setIsLoading(false);
        };
        getAppSettings();
    }, []);

    return {
        isLoading,
        isError,
        contentId,
        publicContentBaseUrl,
        kinesisFirehoseStreamLocale,
        quickLinkId,
    };
};

export default useContentBuild;
